import React from "react";

const WaterGlassIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.5183 0.141176C18.4478 0.0705882 18.3301 0 18.1889 0H1.81246C1.69482 0 1.57717 0.0470588 1.48305 0.141176C1.41246 0.235294 1.3654 0.352941 1.38893 0.494118L4.11834 19.6235C4.14187 19.8353 4.33011 20 4.54187 20H15.4595C15.6713 20 15.8595 19.8353 15.883 19.6235L18.6125 0.494118C18.636 0.376471 18.5889 0.235294 18.5183 0.141176ZM15.083 19.1294H4.91834L3.10658 6.47059C4.35364 5.97647 5.03599 6.25882 5.88305 6.61176C6.47129 6.84706 7.10658 7.12941 7.95364 7.12941C8.5654 7.12941 9.27129 6.98824 10.1654 6.61176C11.6007 5.95294 12.3301 6.25882 13.2478 6.63529C13.836 6.87059 14.4713 7.15294 15.3183 7.15294C15.7654 7.15294 16.2595 7.08235 16.8478 6.89412L15.083 19.1294ZM16.9889 5.88235C15.3419 6.54118 14.4948 6.18824 13.6007 5.81176C12.6595 5.41177 11.6242 4.98824 9.83599 5.81176C8.04776 6.58824 7.17717 6.21176 6.23599 5.81176C5.38893 5.45882 4.47129 5.08235 2.98893 5.6L2.30658 0.870588H17.6948L16.9889 5.88235Z"
      fill="#191919"
    />
  </svg>
);

export default WaterGlassIcon;
